import { TableColumnData, RadioButton } from "@king-ict/eupisi-ui/components";
import { TFunction } from "i18next";

import { getCommitteeEmployeeDisplayName } from "./employee.util";
import {
  CommitteeEmployee,
  CountyCommittee,
  InstitutionCommittee,
  MinistryCommittee,
  RegionalCommittee,
} from "../../../models/Committee";
import { FormatUtils, UuidUtils } from "../../../utils";

export const generateCommitteeTableColumns = (
  t: TFunction
): TableColumnData<CommitteeEmployee>[] => {
  return [
    {
      headerClassName: "col-4",
      columnKey: "expertCommissionRole",
      header: t("common.expertCommission.role"),
      accessor: ({ committeeRole }) => {
        return <div>{committeeRole.name}</div>;
      },
    },
    {
      headerClassName: "col-6",
      columnKey: "employee",
      header: t("common.expertCommission.employee"),
      accessor: (item: CommitteeEmployee) => {
        return <div>{getCommitteeEmployeeDisplayName(item)}</div>;
      },
    },
    {
      headerClassName: "col-4",
      columnKey: "activeTo",
      header: t("common.expertCommission.activeTo"),
      accessor: ({ deactivationDate }) => {
        return <div>{FormatUtils.formatDate(deactivationDate)}</div>;
      },
    },
    {
      headerClassName: "col-1",
      columnKey: "president",
      header: t("common.expertCommission.president"),
      accessor: ({ isPresident, committeeRole }) => {
        return (
          <div className="pt-2 ml-3">
            <RadioButton
              ariaLabel="item.president"
              key={committeeRole.id}
              name={"item.president"}
              checked={isPresident}
              value={committeeRole.id}
              disabled
            />
          </div>
        );
      },
    },
  ];
};

export const addRowKeyIdToTableData = (
  committee:
    | InstitutionCommittee
    | RegionalCommittee
    | CountyCommittee
    | MinistryCommittee
): CommitteeEmployee[] => {
  return (
    committee.employees?.map((employee) => ({
      ...employee,
      rowKeyId: UuidUtils.generateUuid(),
    })) || []
  );
};
